import { render, staticRenderFns } from "./VueStar.vue?vue&type=template&id=660302ae&"
import script from "./VueStar.vue?vue&type=script&lang=js&"
export * from "./VueStar.vue?vue&type=script&lang=js&"
import style0 from "./VueStar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports